export type SnTitleUpdateEvent = string;
